'use client';

import Link from 'next/link';
import { Button } from '@mantine/core';

export const RedirectUpdate = ({ slug }: { slug: string }) => {
  return (
    <Button component={Link} href={`/admin/articles/${slug}`}>
      Modifier sur l'espace administrateur
    </Button>
  );
};
